/** A cleaner's page keeps its tab in the address, so a link can open Messages. */
import { z } from 'zod'

export const cleanerTabs = ['overview', 'jobs', 'messages'] as const
export type CleanerTab = (typeof cleanerTabs)[number]

export const cleanerTabLabels: Record<CleanerTab, string> = {
  overview: 'Overview',
  jobs: 'Jobs',
  messages: 'Messages',
}

export const cleanerPageSearchSchema = z.object({
  tab: z.enum(cleanerTabs).optional().catch(undefined),
})
